import { useIntl } from "react-intl";

const UserCounts = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.UserCounts.header",
            defaultMessage: "User counts"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.UserCounts.content",
            defaultMessage:
                "User counts gives Atlassian admins visibility into how many users they are able to add to an Enterprise product; and conversely, user counts indicate if a product is at-or-near capacity."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
        </>
    );
};

export default UserCounts;
